var exports = {
  "k": "InviteDateToggle.module__container___dW1fRj",
  "P": "InviteDateToggle.module__label___dW1fRj",
};

module.exports = exports;
